import { create } from 'zustand';
import { FormDataCreateCompetencyModule } from 'types/dacum/moduleManagement';

interface ModuleManagementFormData extends FormDataCreateCompetencyModule {
  trCompetencyModuleID?: string;
  courseName?: string;
  dateIn?: string;
  userIn?: string;
  dateUp?: string | null;
  userUp?: string | null;
}

interface ModuleManagementStore {
  formData: ModuleManagementFormData;
  mode: 'add' | 'edit' | 'view';
  setFormData: (_data: Partial<ModuleManagementFormData>) => void;
  setMode: (_mode: 'add' | 'edit' | 'view') => void;
  reset: () => void;
}

const initialFormData: ModuleManagementFormData = {
  msCompetencyManagementID: '',
  msLCMSCourseID: '',
  deliveryMode: '',
  liaType: '',
  trCompetencyModuleID: '',
  courseName: '',
  dateIn: '',
  userIn: '',
  dateUp: null,
  userUp: null
};

export const useModuleManagementStore = create<ModuleManagementStore>((set) => ({
  formData: initialFormData,
  mode: 'add',
  setFormData: (_data) =>
    set((state) => ({
      formData: { ...state.formData, ..._data }
    })),
  setMode: (_mode) => set({ mode: _mode }),
  reset: () => set({ formData: initialFormData, mode: 'add' })
}));
